import React from "react";

// Components
import Header from "./components/layout/Header";
import HeaderBanner from "./components/layout/HeaderBanner";
import MainPage from "./pages/loan-calculator-calendar/MainPage";

const App = () => {
  return (
    <>
      <Header />
      <HeaderBanner />
      <MainPage />
    </>
  );
};

export default App;
